import * as THREE from 'three';

export class FikoToonShader extends THREE.ShaderMaterial {
  constructor() {
    super({
      uniforms: {
        uColor: { value: new THREE.Color(0x00aaff) }, // Default color
        uLightDirection: { value: new THREE.Vector3(0.0, 0.0, 1.0) }, // Default light direction
        uToonLevels: { value: 3.0 }, // 3 levels of shading
      },
      vertexShader: `
        varying vec3 vNormal;
        varying vec3 vViewDir;

        void main() {
          vNormal = normalize(normalMatrix * normal);
          vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
          vViewDir = normalize(-mvPosition.xyz);
          gl_Position = projectionMatrix * mvPosition;
        }
      `,
      fragmentShader: `
        precision highp float;
        uniform vec3 uColor;
        uniform vec3 uLightDirection;
        uniform float uToonLevels;
        varying vec3 vNormal;
        varying vec3 vViewDir;

        float toonify(float value, float levels) {
          return floor(value * levels) / levels;
        }

        void main() {
          vec3 normal = normalize(vNormal);
          vec3 lightDir = normalize(uLightDirection);
          float NdotL = dot(normal, lightDir);
          float diffuse = max(NdotL, 0.0);
          diffuse = toonify(diffuse, uToonLevels);

          float rim = 1.0 - max(dot(normal, normalize(vViewDir)), 0.0);
          rim = smoothstep(0.6, 0.8, rim);

          vec3 ambient = uColor * 0.2;
          vec3 color = ambient + uColor * diffuse * 0.8 + vec3(1.0) * rim * 0.3;

          gl_FragColor = vec4(color, 1.0);
        }
      `,
      lights: false,
      side: THREE.DoubleSide,
      dithering: true,
    });
  }
}
